
import ARRAY from "../../../UTIL/ARRAY";
import CONQUER from "../../CONQUER";
import GameInstance from "../GameInstance";
import LOG, { log } from "../../../UTIL/LOG";
import { ACTIONS } from "../../../Models/ENUM";
import MATH from "../../../UTIL/MATH";
 

class Lives
{
    private conquer         : CONQUER;
    private gameInstance    : GameInstance;
 
    private meVar           : string = "PlayerLives";
 
    public vars             : any = {};
    public color            : string = "";
    public value            : number = 1;
    public max              : number = 1;
 
    constructor( gameInstance:GameInstance )
    {
        this.conquer        = gameInstance.conquer;
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;
    }
 
    public reset()
    {
        this.max = MATH.clamp( this.gameInstance.CONFIG.LIVES.max || 1, this.gameInstance.CONFIG.LIVES.value, 0 );
        this.set( this.gameInstance.CONFIG.LIVES.value );
    }

    public setConfig( vars:any )
    {
        this.value = this.gameInstance.Data.display( this.meVar + "Config", vars );
    }

    public set( newValue:number )
    {
        newValue = MATH.clamp( newValue, this.max, 0 );
        this.value = this.conquer.Avatars.ME.vars.lives = this.gameInstance.Data.display( this.meVar, newValue );
        return this.value;
    }
 
    public increase( value:number=1 )
    {
        return this.set( this.value+value);
    };

    public decrease( value:number=1 )
    {
        this.set( this.value-value);
        return this.value;
    };
 
    public get() 
    {
        return this.gameInstance.Data.get( this.meVar );
    }
 

};

export default Lives;